export default __webpack_public_path__ + "bef137c296c10ea7f1ffa076f9da63a4.png";